export enum NewRelicResourceType {
    PlatformApi = 'PlatformApi',
}
